import { Sentry } from '~publish/components/ErrorBoundary/PublishSentryClient'

/**
 * Breadcrumbs only: a failed silent refresh is recoverable on its own, so these
 * add context to whatever actionable error is captured later rather than raising
 * issues of their own. Never include token values or PII.
 */
const BREADCRUMB_CATEGORY = 'auth.refresh'

function addRefreshBreadcrumb(
  message: string,
  level: 'info' | 'warning' | 'error',
): void {
  Sentry.addBreadcrumb({ category: BREADCRUMB_CATEGORY, message, level })
}

export function trackLogoutOnRefreshFailure(): void {
  addRefreshBreadcrumb('OIDC logout after refresh failure', 'error')
}

export function trackImpersonateStopRedirect(): void {
  addRefreshBreadcrumb('OIDC stop impersonation on refresh', 'info')
}
